module.exports = __webpack_public_path__ + "img/8_44.8dfdc31b.png";